import styled from 'styled-components';

export const Base = styled.div`
	width: 100%;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding-top: 3px;
	box-sizing: border-box;
`;

export const Label = styled.div`
	margin-left: 2px;
	user-select: none;
	font-size: 12px;
	color: ${({ theme }) => theme.gray['1000']};
	pointer-events: none;
	margin-bottom: 3px;
`;

export const Icon = styled.div`
	pointer-events: none;
`;
